/**
 * Created by intellicar-sunny on 4/07/20.
 */
import React, { Component } from "react";
import "../EVReport.css";
import "./EVTrip.css";
import _ from "lodash";
import { connect } from "react-redux";
import moment from "moment";
import ReportAPIs from "../../../../../APIs/ReportAPIs";
import { evAnalyticsColor } from "../../../../../constants/constants";
import EVLoader from "../../../../EVLoader";
import Toggle from "../../../../ToggleButton";
const colorArray = [
  "#6a9e6d",
  "#c78752",
  "#3c80ce",
  "#e0d975",
  "#cd7391",
  "#9f3fc5",
  "	#ffa600",
  "#0a5477",
  "#bd71ef",
  "#0fc111",
  "#966868",
  "#50b6bb",
];
class EVTrip extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openBuket: [],
      activeReport: null,
      busy: false,
      isLoading: false,
      filteredReport: [],
      isLoaded: false,
      openDailyBucket: [],
      isDaily: true,
    };
    this.sortEVReport = this.sortEVReport.bind(this);
    // document.getElementsByClassName("rw-container")[0].style.top = "53px";
  }
  componentWillMount() {
    if (this.props.evReport) {
      this.setState({ filteredReport: this.props.evReport.history });
    }
  }
  componentWillReceiveProps(props) {
    if (props.evReport) {
      this.setState({ filteredReport: props.evReport.history });
    }
  }

  componentDidMount() {
    document.getElementsByClassName("rw-container")[0].style.top = "53px";
    document.getElementsByClassName("rw-toolbar")[0].style.display = "flex";
    if (this.props.evReportBuckets.length > 0) {
      var elmnt = document.getElementById(
        "model" + this.props.evReportBuckets[0]
      );
      elmnt.scrollIntoView();
    }
  }
  componentWillUnmount() {
    document.getElementsByClassName("rw-container")[0].style.top = "95px";
  }

  renderTableRows = (data) => {
    let rows = [];
    for (let idx in data.val) {
      rows.push(
        <tr>
          {data.val[idx].map((val, key) => {
            return (
              <td>
                {val === null
                  ? "-"
                  : this.formatter(this.props.evReport.meta[key].type, val)}
              </td>
            );
          })}
        </tr>
      );
    }
    return rows;
  };

  formatter = (key, data) => {
    switch (key) {
      case "date":
        return moment(data).format("DD MMM YY HH:mm A");
      case "timestr":
        return (
          parseInt(moment.duration(data).days() * 24) +
          parseInt(moment.duration(data).hours()) +
          " hr " +
          " " +
          moment.duration(data).minutes() +
          " min "
        );
      case "event":
        return data === "c" ? "Charging" : "Trip";
      default:
        return data ? data : "NA";
    }
  };

  handleDailyBucket(idx) {
    let buckets = this.state.openDailyBucket;
    if (buckets.includes(idx)) {
      var index = buckets.indexOf(idx);
      if (index !== -1) {
        buckets.splice(index, 1);
        this.setState({ openDailyBucket: buckets });
      }
    } else {
      this.setState({ openDailyBucket: [...buckets, idx] });
    }
  }

  getHourMin(milisec) {
    let hourmin = moment.duration(milisec);
    if (hourmin.hours() > 0 && hourmin.minutes() > 0) {
      return `${hourmin.hours()} hr ${hourmin.minutes()} min`;
    } else if (hourmin.hours() == 0 && hourmin.minutes() > 0) {
      return `${hourmin.minutes()} min`;
    } else {
      return `${hourmin.hours()} hr`;
    }
  }

  renderTrips(data) {
    let trips = [];
    let header = this.props.evReport.meta.trip;
    for (let idx in data) {
      trips.push(
        <div className="tripDetailContainer">
          <div className="tripNo">
            <div className="countBox">{parseInt(idx) + 1}</div>
          </div>
          <div className="tripDetail">
            <div className="tripId">
              {data[idx].state === "d" ? (
                <i style={{ color: "#e74c3c" }} className="fas fa-route"></i>
              ) : (
                <i
                  className="fas fa-charging-station"
                  style={{ color: "#2ecc71" }}
                ></i>
              )}
            </div>
            <div className="tripState"></div>
            <div className="tripStats">
              <div className="tripTime">
                <div className="tripStart">
                  <div
                    className="colorBox"
                    style={{ backgroundColor: evAnalyticsColor[0] }}
                  ></div>

                  <div className="stats">
                    <div className="statsLabel">{header.starttime.heading}</div>
                    <div className="statsValue">
                      {moment(data[idx].starttime).format("DD MMM YYYY h:mm A")}
                    </div>
                  </div>
                </div>
                <div className="tripEnd">
                  <div
                    className="colorBox"
                    style={{ backgroundColor: evAnalyticsColor[1] }}
                  ></div>
                  <div className="stats">
                    <div className="statsLabel">{header.endtime.heading}</div>
                    <div className="statsValue">
                      {moment(data[idx].endtime).format("DD MMM YYYY h:mm A")}
                    </div>
                  </div>
                </div>
              </div>
              <div className="tripVoltage">
                <div className="voltageStart">
                  <div
                    className="colorBox"
                    style={{ backgroundColor: evAnalyticsColor[2] }}
                  ></div>

                  <div className="stats">
                    <div className="statsLabel">{header.startvolt.heading}</div>
                    <div className="statsValue">
                      {data[idx].startvolt.toString().includes("-")
                        ? "NA"
                        : data[idx].startvolt}{" "}
                      {data[idx].startvolt.toString().includes("-")
                        ? ""
                        : header.startvolt.unit}
                    </div>
                  </div>
                </div>
                <div className="voltageEnd">
                  <div
                    className="colorBox"
                    style={{ backgroundColor: evAnalyticsColor[3] }}
                  ></div>
                  <div className="stats">
                    <div className="statsLabel">{header.endvolt.heading}</div>
                    <div className="statsValue">
                      {data[idx].endvolt.toString().includes("-")
                        ? "NA"
                        : data[idx].startvolt}{" "}
                      {data[idx].startvolt.toString().includes("-")
                        ? ""
                        : header.endvolt.unit}
                    </div>
                  </div>
                </div>
              </div>

              <div className="tripSOC">
                <div className="startSOC">
                  <div
                    className="colorBox"
                    style={{ backgroundColor: evAnalyticsColor[4] }}
                  ></div>

                  <div className="stats">
                    <div className="statsLabel">{header.startsoc.heading}</div>
                    <div className="statsValue">
                      {data[idx].startsoc.toString().includes("-")
                        ? "NA"
                        : data[idx].startsoc}{" "}
                      {data[idx].startsoc.toString().includes("-")
                        ? ""
                        : header.startsoc.unit}
                    </div>
                  </div>
                </div>
                <div className="endSOC">
                  <div
                    className="colorBox"
                    style={{ backgroundColor: evAnalyticsColor[5] }}
                  ></div>
                  <div className="stats">
                    <div className="statsLabel">{header.endsoc.heading}</div>
                    <div className="statsValue">
                      {data[idx].endsoc.toString().includes("-")
                        ? "NA"
                        : data[idx].endsoc}{" "}
                      {data[idx].endsoc.toString().includes("-")
                        ? ""
                        : header.endsoc.unit}
                    </div>
                  </div>
                </div>
              </div>

              {data[idx].state === "d" ? (
                <div className="tripDistance">
                  <div className="distance">
                    <div
                      className="colorBox"
                      style={{ backgroundColor: evAnalyticsColor[9] }}
                    ></div>

                    <div className="stats">
                      <div className="statsLabel">
                        {header.distance.heading}
                      </div>
                      <div className="statsValue">
                        {data[idx].distance || "NA"}{" "}
                        {data[idx].distance ? header.distance.unit : ""}
                      </div>
                    </div>
                  </div>

                  <div className="distance">
                    <div
                      className="colorBox"
                      style={{ backgroundColor: evAnalyticsColor[10] }}
                    ></div>

                    <div className="stats">
                      <div className="statsLabel">
                        {header.dischargeduration.heading}
                      </div>
                      <div className="statsValue">
                        {data[idx].dischargeduration
                          ? this.getHourMin(data[idx].dischargeduration)
                          : "NA"}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
              {data[idx].state === "d" ? (
                <div className="tripDistance">
                  <div className="distance">
                    <div
                      className="colorBox"
                      style={{ backgroundColor: evAnalyticsColor[11] }}
                    ></div>
                    <div className="stats">
                      <div className="statsLabel">
                        {header.socconsumed.heading}
                      </div>
                      <div className="statsValue">
                        {data[idx].socconsumed || "NA"}{" "}
                        {data[idx].socconsumed ? header.socconsumed.unit : ""}
                      </div>
                    </div>
                  </div>

                  <div className="distance">
                    <div
                      className="colorBox"
                      style={{ backgroundColor: evAnalyticsColor[12] }}
                    ></div>
                    <div className="stats">
                      <div className="statsLabel">{header.mileage.heading}</div>
                      <div className="statsValue">
                        {data[idx].mileage || "NA"}{" "}
                        {data[idx].mileage ? header.mileage.unit : ""}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {data[idx].state === "c" ? (
                <div className="tripDistance">
                  <div className="distance">
                    <div
                      className="colorBox"
                      style={{ backgroundColor: evAnalyticsColor[11] }}
                    ></div>
                    <div className="stats">
                      <div className="statsLabel">SOC Charged</div>
                      <div className="statsValue">
                        {data[idx].soccharged || "NA"}{" "}
                        {data[idx].soccharged ? "%" : ""}
                      </div>
                    </div>
                  </div>
                  <div className="distance">
                    <div
                      className="colorBox"
                      style={{ backgroundColor: evAnalyticsColor[12] }}
                    ></div>
                    <div className="stats">
                      <div className="statsLabel">Charge Duration </div>
                      <div className="statsValue">
                        {data[idx].chargeduration
                          ? this.getHourMin(data[idx].chargeduration)
                          : "NA"}{" "}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      );
    }
    return trips;
  }
  handleBucket(key) {
    window.dispatchStoreEvent({
      type: "SET_EV_REPORT_BUCKET_OPEN",
      payload: key,
    });
  }

  getVehicleNo(vehicleId) {
    let vehicles = this.props.selectedVehicle;
    let result = vehicles.find((vehicle) => vehicle.id == vehicleId);
    return result.name;
  }

  searchReport(key) {
    let processData = this.props.evReport.history;
    let filteredReport = [];
    if (key.length >= 2) {
      for (let idx in processData) {
        if (
          processData[idx].vehicleid.toString().includes(key) ||
          processData[idx].vehicleno.includes(key.toUpperCase()) ||
          (processData[idx].model && processData[idx].model.includes(key))
        ) {
          filteredReport.push(processData[idx]);
        }
      }
      this.setState({ filteredReport: filteredReport });
    } else {
      this.setState({ filteredReport: processData });
    }
  }

  copyVehicle(containerid) {
    var r = document.createRange();
    r.selectNode(document.getElementById(containerid));
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(r);
    document.execCommand("copy");
    window.getSelection().removeAllRanges();
  }
  renderDaily(daily, parentIdx) {
    let reportBoxes = [];
    let header = this.props.evReport.meta.summary;
    for (let idx in daily) {
      reportBoxes.push(
        <div className="reportBox" key={"daily" + idx}>
          <div className="reportBox-Header">
            <div className="headerMeta">
              <div className="vehicleCount">{parseInt(idx) + 1}</div>

              <div className="Date">
                <i className="fal fa-calendar-day"></i>
                <div>
                  {moment(parseInt(daily[idx].date)).format("DD MMM YYYY")}
                </div>
              </div>
            </div>
            <div
              className="Insight"
              onClick={() =>
                this.handleDailyBucket("daily" + parentIdx + "" + idx)
              }
            >
              {this.renderTripSummary(daily[idx].stats)}
            </div>
          </div>
          {this.state.openDailyBucket.includes(
            "daily" + parentIdx + "" + idx
          ) ? (
            <div className="reportBox-Body">
              {this.renderTrips(daily[idx].values)}
            </div>
          ) : null}
        </div>
      );
    }
    return reportBoxes;
  }

  renderTripSummary(summary) {
    let objToArr = Object.entries(summary);
    let header = this.props.evReport.meta.summary;
    let items = [];
    for (let idx in objToArr) {
      items.push(
        <div className="holisticInsight" key={idx}>
          <div
            className="colorBox"
            style={{ backgroundColor: evAnalyticsColor[idx] }}
          ></div>
          <div className="stats">
            <div className="statsLabel">{header[objToArr[idx][0]].heading}</div>
            <div className="statsValue">
              {objToArr[idx][1] !== null
                ? objToArr[idx][1] +
                  " " +
                  (header[objToArr[idx][0]].unit
                    ? header[objToArr[idx][0]].unit
                    : "")
                : "NA"}
            </div>
          </div>
        </div>
      );
    }
    return items;
  }
  getTripData(data) {
    let finalArray = [];
    for (let idx in data) {
      finalArray.push(...data[idx].values);
    }
    return finalArray;
  }
  renderLayout() {
    let reportBoxes = [];
    let header = this.props.evReport.meta.summary;
    let trip = this.state.filteredReport;
    for (let idx in trip) {
      reportBoxes.push(
        <div className="reportBox" key={idx}>
          <div
            className="reportBox-Header"
            style={{
              opacity: trip[idx].data.data.length > 0 ? 1 : "0.3",
              backgroundColor:
                trip[idx].data.data.length > 0 ? "white" : "#e6e6e6",
            }}
          >
            <div className="headerMeta">
              <div className="vehicleCount">{parseInt(idx) + 1}</div>
              <div
                className="summaryInsight"
                id={"vehicle" + idx}
                onClick={() => this.copyVehicle("vehicle" + idx)}
              >
                {/* <div className="label">Vehicle No</div>{" "} */}
                <div className="vehicleName">{trip[idx].vehicleno}</div>
              </div>
              <div
                className="summaryInsight"
                id={"model" + idx}
                onClick={() => this.copyVehicle("model" + idx)}
              >
                {/* <div className="label">Vehicle ID</div>{" "} */}
                <div className="vehicleId">{trip[idx].model}</div>
              </div>
            </div>
            <div className="Insight" onClick={() => this.handleBucket(idx)}>
              {this.renderTripSummary(trip[idx].data.stats)}
            </div>
          </div>
          {this.props.evReportBuckets.includes(idx) ? (
            <div className="reportBox-Body">
              {this.state.isDaily
                ? this.renderDaily(trip[idx].data.data, idx)
                : this.renderTrips(this.getTripData(trip[idx].data.data))}
            </div>
          ) : null}
        </div>
      );
    }
    return reportBoxes;
  }

  renderNoData() {
    return (
      <div className="noData">
        <div style={{ margin: "auto" }}>No Data</div>
      </div>
    );
  }
  sortEVReport(e) {
    // let sortedReport= _.orderBy(this.props.evReport, report => report[0][e.target.value], ["desc"]);
    let sortedReport = this.props.evReport.sort((a, b) =>
      a[0][e.target.value] > b[0][e.target.value]
        ? 1
        : b[0][e.target.value] > a[0][e.target.value]
        ? -1
        : 0
    );

    //   sortedReport= sortedReport.sort(function (a, b) {
    //     console.log("sorted report",a[0][e.target.value])
    //     return (a[0][e.target.value] === null) - (b[0][e.target.value] === null);
    // });
    this.setState({
      filteredReport: this.state.filteredReport.concat(sortedReport),
    });
    // this.props.dispatch({
    //   type: "SAVE_EV_DASHBOARD_DATA",
    //   data: sortedReport,
    // });
  }
  render() {
    return (
      <div className="EVReport">
        <div className="reportContainer">
          {this.props.evLoading ? (
            <div
              className="EvDetailDesc"
              style={{
                height: "90%",
                alignItems: "center",
                display: "flex",
              }}
            >
              <EVLoader countTime={20} isLoading={this.props.isLoading} />
            </div>
          ) : (
            <div style={{ display: "flex" }}>
              <div
                style={{ display: "flex", overflowX: "auto", width: "100%" }}
              >
                <div style={{ width: "100%", padding: "5px 20px" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <div
                      className="searchContainer"
                      style={{
                        justifyContent:
                          this.props.evReport !== null
                            ? "space-between"
                            : "flex-end",
                      }}
                    >
                      {this.props.evReport !== null ? (
                        <div className="searchBox">
                          <div>
                            <i className="far fa-search"></i>
                          </div>
                          <input
                            type="text"
                            placeholder="Search"
                            onChange={(e) => this.searchReport(e.target.value)}
                          />
                        </div>
                      ) : null}
                      {this.props.evReport !== null ? (
                        <div className="dashboardTo">
                          <Toggle
                            selected={this.state.isDaily}
                            toggleSelected={() => {
                              this.setState({ isDaily: !this.state.isDaily });
                            }}
                          />
                        </div>
                      ) : null}
                      <div className="info">
                        * You can select a maximum date range of 15 days
                      </div>
                    </div>
                    {/* <div className="sortContainer">
                      <select onChange={this.sortEVReport} >
                      <option>
                          Sort By
                        </option>
                        <option value="totsocconsumed">
                          Soc
                        </option>
                        <option value="mileage">
                          Mileage
                        </option>
                        <option value="totaldistance">
                          Distance
                        </option>
                        <option value="totalchargingevents">
                          Charging Events
                        </option>
                        <option value="totaldischargingevents">
                          Discharging Events
                        </option>

                      </select>
                    </div> */}
                  </div>
                  {this.props.evReport !== null ? (
                    <div
                      style={{ overflowY: "auto", height: 500, padding: 10 }}
                    >
                      {this.state.filteredReport.length > 0
                        ? this.renderLayout()
                        : this.renderNoData()}
                    </div>
                  ) : (
                    this.renderNoData()
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}
const mapPropsToState = (state) => {
  return {
    evReport: state.evReport,
    selectedVehicle: state.selectedVehicle,
    evLoading: state.evLoading,
    evReportBuckets: state.evReportBuckets,
  };
};

export default connect(mapPropsToState)(EVTrip);
